import { AbstractControl, ValidationErrors } from '@angular/forms';

export function cadConnectorIdValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const value = typeof control.value === 'string' ? control.value.trimEnd() : control.value;
  const nameRegExp = /^\s*(\S+)(\s+(\S+))*$/;

  const forbidden = !nameRegExp.test(value);
  return forbidden ? { noSymbols: true } : null;
}
